export default __webpack_public_path__ + "static/media/BgDeco.951e9d91.png";